import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { Booking } from '@yiluhub/yilu-amp-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BookingTerms } from 'components/BookingConfirmation/components';
import 'components/BookingConfirmation/styles.scss';

import { ParkingBookingInfo } from './ParkingBookingInfo';
import './styles.scss';

type ParkingBookingConfirmationProps = {
  booking: Booking<'COMPLETED', 'PARKING'>;
};

export const ParkingBookingConfirmation: React.FC<ParkingBookingConfirmationProps> = ({
  booking,
}) => {
  const { t } = useTranslation();

  const bookingData = booking.product.data;

  const getEmailCheck = (parkingBooking: Booking<'COMPLETED', 'PARKING'>) => {
    let provider = '';
    if (parkingBooking.serviceProvider === 'Free2Move') {
      provider = parkingBooking.serviceProvider;
    } else {
      provider = parkingBooking.product.data.parkingDetails.location.address || 'POI';
    }

    return t('parking.bcp.successMessage', {
      email: parkingBooking.product.data.customerDetails.email,
      provider: provider,
    });
  };

  return (
    <>
      {bookingData && (
        <>
          <ElementsSDK.Message
            className="yilu-payment-bcp-success__message"
            type={ElementsSDK.MessageType.SUCCESS}
            content={getEmailCheck(booking)}
          />
          <ParkingBookingInfo booking={booking} />
          <BookingTerms opensNewtab termsUrl={bookingData.parkingDetails.termsUrl} />
        </>
      )}
    </>
  );
};
